// @flow
import React, { Component, lazy, Suspense } from "react";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Grid from "@material-ui/core/Grid";

import UserStatusLabel from "../../../account/components/users/UserStatusLabel";
import { LoadingProgress, NoItem } from "imagus-components";

const UserAdminItemRedux = lazy((): * => import("../../containers/users/UserAdminItemRedux.js"));

type UserListStatesType = {
  expanded: null | boolean
};

type UserListPropsType = {
  users: Array<*>,
  openSnackbar: Function,
  setActionError: Function,
  companyFilter?: Array<*>,
  statusFilter?: string
};

class UserList extends Component<UserListPropsType, UserListStatesType> {
  constructor(props: UserListPropsType) {
    super(props);
    this.state = {
      expanded: null
    };
  }

  handleChange = (panel: *): * => (event: Event, expanded: *): * => {
    this.setState({
      expanded: expanded ? panel : false
    });
  };

  render(): * {
    const { expanded } = this.state;
    const users = this.props.users;
    const list =
      users &&
      users.map(
        (user: *, i: number): * => {
          let display = true;
          if (this.props.companyFilter && this.props.companyFilter.length > 0) {
            if (this.props.companyFilter.indexOf(user.company.uuid) < 0) {
              display = false;
            }
          }
          if (this.props.statusFilter && this.props.statusFilter !== "ALL") {
            if (this.props.statusFilter === "CONFIRMED") {
              if (user.user_status !== "CONFIRMED") {
                display = false;
              }
            }
            if (this.props.statusFilter === "UNCONFIRMED") {
              if (user.user_status === "CONFIRMED") {
                display = false;
              }
            }
          }
          if (display) {
            return (
              <ExpansionPanel
                expanded={expanded === user.uuid}
                onChange={this.handleChange(user.uuid)}
                key={user.uuid}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1" className="heading">
                    <b>User Name</b> {user.fullName}
                  </Typography>
                  <Typography variant="subtitle1" className="heading">
                    <b>Company</b> {user.company.name}
                  </Typography>
                  <Typography variant="subtitle1" className="heading">
                    <UserStatusLabel userStatus={user.user_status} />
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Suspense fallback={<LoadingProgress />}>
                    <UserAdminItemRedux
                      user={user}
                      openSnackbar={this.props.openSnackbar}
                      setActionError={this.props.setActionError}
                      expanded={expanded === user.uuid}
                    />
                  </Suspense>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            );
          } else {
            return null;
          }
        }
      );

    return (
      <div className="app-panel-content panel-top-margin">
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {list.filter(item => item !== null).length === 0 ? (
              <NoItem content="No User has found." />
            ) : (
              list
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default UserList;
